import React, { useEffect, useRef, useState } from 'react'
import { Button, Col, Container, Row } from 'reactstrap'
import { Modal } from "react-bootstrap";
import { IoAddCircle, IoSearchOutline } from "react-icons/io5";
import { useSelector } from 'react-redux';
import { numberWithCommas } from '../../utils/customFunction';
import { getAllPsx, getAllSecurities } from '../../stores/services/security.service';
import { getFundByAmc } from '../../stores/services/funds.service';
import { toast, ToastContainer } from 'react-toastify';
import moment from 'moment';
import { VscSplitVertical } from "react-icons/vsc";
import { AiFillMinusCircle } from 'react-icons/ai';
import NumberFormat from 'react-number-format';
import MarketPortfolioTable from './MarketPortfolioTable';
import MarketPortfolioCard from './MarketPortfolioCard';
import { searchTransactions } from '../../stores/services/transactions.service';
import { addMegaTransaction } from '../../stores/services/beta-transaction.service';


function Market_portfolio() {
    const email = sessionStorage.getItem("email") || "";
    const amc_code = sessionStorage.getItem("amc_code") || "";
    const [tempMarketArr, setTempMarketArr] = useState<any>([]);
    const [marketPortfolio, setMarketPortfolio] = useState<any>([]);
    const [selectedItem, setSelectedItem] = useState<any>([]);
    const [psxListBar, setPsxListBar] = useState<any>([]);
    const [changeView, setChangeView] = useState("Horizontal")
    const [screen, setScreen] = useState<any>()
    const theme = useSelector((state: any) => state.ThemeModeReducer.Theme);
    const [searchCompany, setSearchCompany] = useState("")
    const itemsPerPage = 50
    const [itemsToShow, setItemsToShow] = useState(50);
    const [Loading, setLoading] = useState(false);
    let [activePage, setActivePage] = useState("");
    const [pageSize, setPageSize] = useState("10");
    let [paginationArr, setPaginationArr] = useState([""]);
    const [modalFlag, setModalFlag] = useState<String>("");
    const [unitsLimit, setUnitsLimit] = useState<any>()

    const handleShowMore = () => {
        setItemsToShow(prev => prev + itemsPerPage);
    };

    const getSecurities = async (isFlag = "") => {
        if (isFlag) {
            setLoading(false);
        }
        else {
            setLoading(true);

        }
        try {
            const amcCode: string = sessionStorage.getItem("amc_code") || "";
            const fundRes = await getFundByAmc(
                email,
                amcCode,
                "",
                ""
            );

            if (fundRes?.status == 200 && fundRes?.data?.status == 200) {
                let temp1: any[] = [];
                const AllFunds = fundRes?.data?.data;

                const filteredMoneyMarkets = AllFunds?.filter(({ money_market }) => money_market)
                    .map(({ money_market }) => money_market);

                filteredMoneyMarkets?.forEach((item) => {
                    JSON.parse(item)?.length > 0 && temp1.push(JSON.parse(item));
                });

                const allDataMatchForSecurity = temp1?.flat(1)
                    ?.map((item) => {
                        return {
                            ...item
                        };
                    })
                    ?.filter(obj => Object.keys(obj).length > 0 && obj?.code);

                setMarketPortfolio(allDataMatchForSecurity);
                setTempMarketArr(allDataMatchForSecurity)
            }
        } catch (err: any) {
            if (err.response !== undefined) {
                toast.error(err.response.data.message?.toString());
            } else {
                toast.error("Request Failed!");
            }
        }
        setLoading(false);
    };

    useEffect(() => {
        getSecurities();
    }, []);


    const getImageSrc = (symbol: string) => {
        try {
            return require(`../../assets/psxLogos/${symbol}.png`).default;
        } catch (e) {
            return require(`../../assets/psxLogos/0.png`).default;
        }
    };

    useEffect(() => {
        const handleResize = () => {
            setScreen(window?.outerWidth);
            if (window?.outerWidth <= 768) {
                setChangeView("Vertical")
            }
        };

        handleResize();

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    const handleSetKeys = (data) => {
        const { last_sale_txn, ...rest } = selectedItem;
        const parsedSecurities = JSON.parse(data?.securities)
        const findSecurity = parsedSecurities?.find((ele) => ele?.security_type === selectedItem?.security_type && ele?.type == "Buy")

        let temp = {
            ...rest,
            type: modalFlag,
            investment_type: findSecurity?.investment_type?.trim() || "",
            symbol: findSecurity?.symbol?.trim() || "",
            money_market_face_value: findSecurity?.money_market_face_value?.trim()?.replaceAll(",", "") || "",
            price: findSecurity?.price?.trim()?.replaceAll(",", "") || "",
            yield: findSecurity?.yield?.trim()?.replaceAll(",", "") || "",
            coupon_rate: findSecurity?.coupon_rate?.trim()?.replaceAll(",", "") || "",
            next_coupon_date: findSecurity?.next_coupon_date?.trim() || "",
            last_coupon_date: findSecurity?.last_coupon_date?.trim() || "",
            primary_dealer: findSecurity?.primary_dealer?.trim() || "",
            fund_ips_account: findSecurity?.fund_ips_account?.trim() || "",
            counter_party_ips_account: findSecurity?.counter_party_ips_account?.trim() || "",
            broker_name: findSecurity?.broker_name?.trim() || "",
            settlement_amount: findSecurity?.settlement_amount?.trim()?.replaceAll(",", "") || "",
            total_face_value: findSecurity?.total_face_value?.trim()?.replaceAll(",", "") || "",
            accrued_amount: findSecurity?.accrued_amount?.trim()?.replaceAll(",", "") || "",
            brokerage: findSecurity?.brokerage?.trim() || "",
            premium_discount: findSecurity?.premium_discount?.trim()?.replaceAll(",", "") || "",
            accrued_days: findSecurity?.accrued_days?.trim() || "",
            counter_party_name: findSecurity?.counter_party_name?.trim() || "",
            detail: findSecurity?.detail?.trim() || "",
            principal_amount: findSecurity?.principal_amount?.trim()?.replaceAll(",", "") || "",
            unredeem_value: findSecurity?.unredeem_value?.trim()?.replaceAll(",", "") || "",
            coupon_payment: findSecurity?.coupon_payment?.trim()?.replaceAll(",", "") || "",
            days_of_maturity: findSecurity?.days_of_maturity?.trim() || "",
            average_cost_per_unit: findSecurity?.average_cost_per_unit?.trim()?.replaceAll(",", "") || "",
            average_cost_amount: findSecurity?.average_cost_amount?.trim()?.replaceAll(",", "") || "",
            gain_loss_per_unit: findSecurity?.gain_loss_per_unit?.trim()?.replaceAll(",", "") || "",
            gain_loss_amount: findSecurity?.gain_loss_amount?.trim()?.replaceAll(",", "") || "",
            coupon_days: findSecurity?.coupon_days?.trim() || "",
            settlement_date: findSecurity?.settlement_date?.trim() || "",
        }

        const newObj = JSON.stringify([temp]);

        let tempdata = {
            account_no: data?.account_number,
            account_title: data?.account_title,
            accrued_amount: data?.accrued_amount?.toString() || "",
            amc_code: amc_code,
            announcement_date: data?.announcement_date,
            applicable_offer_price: data?.applicable_offer_price,
            associated_transaction: data?.associated_transaction,
            average_cost_amount: data?.average_cost_amount?.toString() || "",
            average_cost_before_right: data?.average_cost_before_right?.toString() || "",
            balance: data?.balance?.toString() || "",
            bank: data?.bank,
            bonus_credit_date: data?.bonus_credit_date,
            bonus_gross_volume: data?.bonus_gross_volume?.toString() || "",
            bonus_percentage: data?.bonus_percentage?.toString() || "",
            branch: data?.branch,
            broker_commission: data?.broker_commission?.toString() || "",
            brokerage: data?.brokerage?.toString() || "",
            conversion_date: data?.conversion_date,
            cost_after_right: data?.cost_after_right?.toString() || "",
            cost_right: data?.cost_right?.toString() || "",
            cost_right_entitled: data?.cost_right_entitled?.toString() || "",
            counter_account_number: data?.counter_account_number,
            counter_account_title: data?.counter_account_title,
            counter_account_type: data?.counter_account_type,
            counter_bank: data?.counter_bank,
            counter_branch: data?.counter_branch,
            counter_party_ips_account: data?.counter_party_ips_account,
            counter_type: data?.counter_type,
            coupon_rate: data?.coupon_rate?.toString() || "",
            cr_amount: data?.cr_amount?.toString() || "",
            credit_date: data?.credit_date,
            current_holding: data?.current_holding,
            detail: data?.detail,
            difference_right_price: data?.difference_right_price?.toString() || "",
            dividend_date: data?.dividend_date,
            dividend_percentage: data?.dividend_percentage?.toString() || "",
            dividend_rate: data?.dividend_rate?.toString() || "",
            dr_amount: data?.dr_amount?.toString() || "",
            email: email,
            executed_date: data?.executed_date,
            execution_date: data?.execution_date,
            face_value: data?.face_value,
            folio_no: data?.folio_no,
            fund_account: data?.fund_account,
            fund_code: data?.fund_code,
            fund_ips_account: data?.fund_ips_account,
            gain_loss_amount: data?.gain_loss_amount?.toString() || "",
            gross_amount: data?.gross_amount?.toString() || "",
            instruction_date: data?.instruction_date,
            instrument_date: data?.instrument_date,
            instrument_no: data?.instrument_no,
            instrument_type: data?.instrument_type,
            issue_date: data?.issue_date,
            last_coupon_date: data?.last_coupon_date,
            ledgers: data?.ledgers || "[]",
            load_per_unit: data?.load_per_unit?.toString() || "",
            low_balance_agree: data?.low_balance_agree,
            maturity_date: data?.maturity_date,
            maturity_type: data?.maturity_type,
            mode_of_payment: data?.mode_of_payment,
            money_market_face_value: data?.money_market_face_value?.toString() || "",
            nav: data?.nav,
            net_amount: data?.net_amount?.toString() || "",
            net_bonus_volume: data?.net_bonus_volume?.toString() || "",
            net_right_share_volume: data?.net_right_share_volume?.toString() || "",
            next_coupon_date: data?.next_coupon_date,
            offer_price: data?.offer_price?.toString() || "",
            par_value: data?.par_value?.toString() || "",
            payment_type: data?.payment_type,
            percentage_of_discount: data?.percentage_of_discount?.toString() || "",
            period: data?.period,
            premium: data?.premium?.toString() || "",
            premium_discount: data?.premium_discount,
            price: data?.price?.toString() || "",
            primary_dealer: data?.primary_dealer,
            principal_amount: data?.principal_amount?.toString() || "",
            realized: data?.realized?.toString() || "",
            realized_date: data?.realized_date,
            redemption_date: data?.redemption_date,
            redemption_load: data?.redemption_load?.toString() || "",
            reinvest: data?.reinvest?.toString() || "",
            remain_holding: data?.remain_holding?.toString() || "",
            return_date: data?.return_date,
            right_share_credit_date: data?.right_share_credit_date,
            right_share_gross_volume: data?.right_share_gross_volume?.toString() || "",
            right_share_percentage: data?.right_share_percentage?.toString() || "",
            right_share_symbol: data?.right_share_symbol,
            sale_date: data?.sale_date,
            sale_load: data?.sale_load?.toString() || "",
            sale_txn_no: data?.sale_txn_no,
            sales_tax_collector: data?.sales_tax_collector,
            securities: newObj || "[]",
            security_type: data?.security_type,
            settlement_by: data?.settlement_by,
            settlement_date: data?.settlement_date,
            symbol: data?.symbol,
            system_tax: data?.system_tax?.toString() || "",
            tax_cgt: data?.tax_cgt?.toString() || "",
            tax_it_bonus_amount: data?.tax_it_bonus_amount?.toString() || "",
            tax_it_right_share_amount: data?.tax_it_right_share_amount?.toString() || "",
            tax_on_bonus: data?.tax_on_bonus?.toString() || "",
            tax_on_dvidend: data?.tax_on_dvidend?.toString() || "",
            tax_on_right: data?.tax_on_right?.toString() || "",
            tax_sst: data?.tax_sst?.toString() || "",
            tax_type: data?.tax_type,
            tax_wht_it: data?.tax_wht_it?.toString() || "",
            tax_wht_sst: data?.tax_wht_sst?.toString() || "",
            tenor: data?.tenor,
            total_charges: data?.total_charges?.toString() || "",
            total_face_value: data?.total_face_value?.toString() || "",
            total_holding: data?.total_holding?.toString() || "",
            total_market_value: data?.total_market_value?.toString() || "",
            txn_charges: data?.txn_charges?.toString() || "",
            txn_id: "",
            txnr_type: data?.txnr_type,
            type: data?.type,
            unitholder_name: data?.unitholder_name,
            units: selectedItem?.units,
            volume: data?.volume?.toString() || "",
            yield: data?.yield,
            zakat_amount: data?.zakat_amount?.toString() || "",
        }

        return tempdata
    }

    const addMegaTXN = async (newMegaObj) => {
        try {
            let txnResponse = await addMegaTransaction(newMegaObj)
            if (txnResponse?.status === 200) {
                toast.success(
                    `${txnResponse?.data?.message} - ${txnResponse?.data?.txn_id}`
                );
            }
            else {
                toast.error("Error Creating Transaction")
            }
        } catch (error: any) {
            if (error.response !== undefined) {
                toast.error(error.response.data.message);
            } else {
                toast.error("Something went wrong!");
            }
        }
    }

    const handleSecuritySubmit = async () => {
        try {
            let txndata = await searchTransactions(
                email,
                amc_code,
                "",
                "",
                selectedItem?.last_sale_txn || "",
                "",
                ""
            )
            if (txndata?.status === 200 && txndata?.data?.data?.length > 0) {
                if (txndata?.data?.data[0]) {
                    let newMegaObj = handleSetKeys(txndata?.data?.data[0])
                    addMegaTXN(newMegaObj)
                }
            }
        } catch (error: any) {
            if (error.response !== undefined) {
                toast.error(error.response.data.message);
            } else {
                toast.error("Something went wrong!");
            }
        }
    }

    return (
        <div className="content">
            <ToastContainer />

            <Modal
                dialogClassName="modal90w"
                centered={true}
                show={modalFlag}
                size="lg"
                backdrop={true}
                onHide={() => {
                    setModalFlag("");
                }}
            >
                <div className={`modal-header p-3 ${modalFlag == "Coupon" || modalFlag == "Maturity" ? "bg-info" : "bg-primary"}`}>
                    <button
                        aria-hidden={true}
                        className="close"
                        data-dismiss="modal"
                        type="button"
                        onClick={() => {
                            setModalFlag("");
                        }}
                    >
                        <i className="tim-icons icon-simple-remove text-white" />
                    </button>
                    <h6
                        style={{
                            fontWeight: 600,
                            textTransform: "uppercase",
                            color: "white",
                        }}
                        className='mb-0 mt-1'
                    // className="title title-up"
                    >{`${modalFlag} Shares`}</h6>
                </div>
                <div className="modal-body">
                    <Row>
                        <Col md={6}
                            className='form-group'
                        >
                            <label>Rate</label>
                            <div className="mb-0">
                                <NumberFormat
                                    // placeholder='Enter Rate'
                                    decimalScale={4}
                                    thousandSeparator={true}
                                    // decimalSeparator={true}
                                    className={`form-control text-right py-1`}
                                />

                            </div>
                        </Col>
                        <Col md={6}
                            className='form-group'
                        >
                            <label>Unit</label>
                            <div className="mb-0">
                                <NumberFormat
                                    isAllowed={(values) => {
                                        const { value } = values;
                                        if (
                                            (+value <= +unitsLimit && +value > 0) ||
                                            value === ""
                                        ) {
                                            return true;
                                        } else {
                                            return false;
                                        }
                                    }}
                                    className={`form-control text-right py-1`}
                                    value={
                                        selectedItem?.units && selectedItem.units !== ""
                                            ? parseFloat(selectedItem.units).toFixed(4)
                                            : ""
                                    }
                                    decimalScale={4}
                                    thousandSeparator={true}
                                    onValueChange={(values) => {
                                        const { value } = values;
                                        setSelectedItem({
                                            ...selectedItem,
                                            units: value
                                        });
                                    }}
                                />
                            </div>
                        </Col>

                    </Row>
                    <div className='d-flex justify-content-end'>
                        <Button
                            onClick={() => {
                                handleSecuritySubmit()
                            }}
                            size="md" color={modalFlag == "Sell" ? "primary" : "info"}
                        >
                            {/* {`${modalFlag} Now`} */}
                            Submit
                        </Button>
                    </div>
                </div>
            </Modal>

            {!Loading ?
                <Row>
                    <Col md="12">
                        <Container fluid>
                            <div
                                style={{
                                    borderRadius: "12px",
                                    borderTopRightRadius: "12px"
                                }}
                                className="card ">
                                <div className="card-body">
                                    <Row
                                        style={{
                                            rowGap: screen <= 1199 ? "13px" : ""
                                        }}
                                        className='d-flex justify-content-between align-items-center mb-3'>
                                        <Col xl="4" md="6" className={`d-flex order-1 ${screen <= 500 ? "flex-column justify-content-center align-items-center" : "justify-content-start"} align-items-center`}>
                                            <h5 className={screen <= 500 ? "text-primary mb-2" : 'text-primary mb-0'}>Market Portfolio</h5>
                                            <div
                                                style={{
                                                    maxWidth: "210px"
                                                }}
                                                className={`input-group ml-2 mb-0 position-relative `}>
                                                <input
                                                    style={{
                                                        borderRadius: "50px",
                                                        textAlign: "left",
                                                        padding: "4px 18px",
                                                        paddingRight: "52px"
                                                    }}
                                                    type={"text"}
                                                    placeholder='Search Company'
                                                    className="form-control"
                                                    value={searchCompany}
                                                    onChange={(e) => {
                                                        setSearchCompany(e?.target?.value)
                                                        if (e?.target?.value) {
                                                            let temp = tempMarketArr?.filter((item) => {
                                                                return (
                                                                    item?.marketData?.name?.toLowerCase()?.includes(e?.target?.value?.toLowerCase()) ||
                                                                    item?.marketData?.code?.toLowerCase()?.includes(e?.target?.value?.toLowerCase())
                                                                );
                                                            });
                                                            setMarketPortfolio(temp)
                                                        }
                                                        else {
                                                            setMarketPortfolio(tempMarketArr)
                                                        }
                                                    }}
                                                />
                                                <div
                                                    style={{
                                                        right: "23px",
                                                        top: "6px",
                                                        zIndex: 45
                                                    }}
                                                    className="position-absolute"
                                                >
                                                    <IoSearchOutline fontSize={20} />
                                                </div>
                                            </div>
                                        </Col>

                                        <Col xl="4" md="6" className={`d-flex order-${screen <= 1199 ? "2" : "3"} justify-content-${screen <= 500 ? "center" : "end"}`}>
                                            <div className='mr-1'>
                                                <VscSplitVertical
                                                    data-toggle="tooltip"
                                                    data-placement="top"
                                                    title={"Table View"}
                                                    onClick={() => {
                                                        setChangeView("Horizontal")
                                                        setItemsToShow(10)
                                                    }}
                                                    className={`${changeView == "Horizontal" ? "text-info" : ""}`}
                                                    style={{
                                                        cursor: "pointer",
                                                        height: "26px",
                                                        width: "26px",

                                                    }}
                                                />
                                                <VscSplitVertical
                                                    data-toggle="tooltip"
                                                    data-placement="top"
                                                    title={"Card View"}
                                                    className={`${changeView == "Vertical" ? "text-info" : ""}`}
                                                    onClick={() => {
                                                        setChangeView("Vertical")
                                                        setItemsToShow(10)
                                                    }}
                                                    style={{
                                                        cursor: "pointer",
                                                        height: "26px",
                                                        width: "26px",
                                                        marginBottom: "5px",
                                                        marginLeft: "2px",
                                                        transform: "rotate(90deg)"
                                                    }}
                                                />
                                            </div>
                                        </Col>
                                    </Row>
                                    {changeView == "Horizontal" ?
                                        <>
                                            <MarketPortfolioTable
                                                data={marketPortfolio?.slice(0, itemsToShow)}
                                                getImageSrc={getImageSrc}
                                                setModalFlag={setModalFlag}
                                                setSelectedItem={setSelectedItem}
                                                setUnitsLimit={setUnitsLimit}
                                            />

                                            {itemsToShow < marketPortfolio?.length && (
                                                <div className='d-flex justify-content-center my-2'>
                                                    <Button
                                                        id='hoverNoEffect'
                                                        style={{
                                                            background: "none"
                                                        }}
                                                        className=' border border-primary'
                                                        size="md"
                                                        onClick={handleShowMore}

                                                    >
                                                        Show More
                                                    </Button>
                                                </div>
                                            )}
                                        </>
                                        :
                                        <Col
                                            style={{
                                                borderTop: "1px solid"
                                            }}
                                            className='col-12'>
                                            <MarketPortfolioCard
                                                data={marketPortfolio}
                                                getImageSrc={getImageSrc}
                                                setModalFlag={setModalFlag}
                                                screen={screen}
                                            />
                                            {/* <Row className='pt-3'>
                                                {marketPortfolio?.slice(0, itemsToShow)?.map((item, index) => {
                                                    const diffValReturn: any = (Number(item?.marketData?.market_value || 0) - Number(item?.marketData?.total_amount || 0))
                                                    const ReturnValInPercentage: any = Number(item?.marketData?.total_amount) == 0 ? 0 : ((Number(diffValReturn) / Number(item?.marketData?.total_amount)) * 100)?.toFixed(2)

                                                    const avgUnitCost: any = Number(item?.marketData?.average_cost_per_unit || 0)?.toFixed(2)
                                                    const totalCost: any = Number(item?.marketData?.total_amount || 0)?.toFixed(2)

                                                    return (
                                                        <Col lg="4" xl="2" md="4" className={`mb-5 ${screen <= 500 ? "pb-3 border-bottom" : ""}`}>
                                                            <div
                                                                style={{
                                                                    rowGap: "10px",
                                                                    borderRadius: "15px",
                                                                    border: "1px solid #1d8cf8 "
                                                                }}
                                                                className='d-flex flex-column align-items-center text-center py-2 shadow'>
                                                                <img
                                                                    src={getImageSrc(item?.marketData?.symbol)}
                                                                    width={50}
                                                                    height={50}
                                                                    style={{
                                                                        objectFit: "contain",
                                                                        objectPosition: "center"
                                                                    }}
                                                                />
                                                                <div
                                                                    style={{ lineHeight: "normal" }}
                                                                    className='d-flex flex-column w-100'>
                                                                    <p
                                                                        style={{ fontWeight: 600 }}
                                                                        data-toggle="tooltip" data-placement="top" title={item?.marketData?.code}
                                                                        className='mb-0 text-primary table_heading_large'>{item?.marketData?.code}</p>
                                                                    <small
                                                                        style={{ whiteSpace: "break-spaces" }}
                                                                        className='text-info'>{item?.marketData?.name}</small>
                                                                </div>
                                                                <div
                                                                    style={{ lineHeight: "normal" }}
                                                                    className='d-flex flex-column align-items-center w-100'>
                                                                    <small
                                                                        style={{ opacity: "0.4" }}
                                                                        className={`smallTagColor-${theme}`}>
                                                                        Next Coupon
                                                                    </small>
                                                                    <p
                                                                        style={{
                                                                            fontWeight: 600,
                                                                            whiteSpace: "break-spaces"
                                                                        }}
                                                                        className='mb-0 table_heading_large text-primary'>
                                                                        {moment(item?.marketData?.issue_date)?.format("DD-MMM-YYYY")}
                                                                    </p>

                                                                </div>
                                                                <div
                                                                    style={{ lineHeight: "normal" }}
                                                                    className='d-flex flex-column align-items-center w-100'>
                                                                    <small
                                                                        style={{ opacity: "0.4" }}
                                                                        className={`smallTagColor-${theme}`}>
                                                                        Days to Coupon
                                                                    </small>
                                                                    <p
                                                                        style={{
                                                                            fontWeight: 600,
                                                                            whiteSpace: "break-spaces"
                                                                        }}
                                                                        className='mb-0 table_heading_large text-primary'>
                                                                        {
                                                                            item?.marketData?.coupon_days || 0
                                                                        }
                                                                    </p>

                                                                </div>
                                                                <div
                                                                    style={{ lineHeight: "normal" }}
                                                                    className='d-flex flex-column align-items-center w-100'>
                                                                    <small
                                                                        style={{ opacity: "0.4" }}
                                                                        className={`smallTagColor-${theme}`}>
                                                                        Units
                                                                    </small>
                                                                    <p
                                                                        style={{
                                                                            fontWeight: 600,
                                                                            whiteSpace: "break-spaces"
                                                                        }}
                                                                        className='mb-0 table_heading_large text-primary'>
                                                                        {
                                                                            numberWithCommas(item?.marketData?.units || 0)
                                                                        }
                                                                    </p>

                                                                </div>
                                                                <div
                                                                    style={{ lineHeight: "normal" }}
                                                                    className='d-flex flex-column align-items-center w-100'>
                                                                    <small
                                                                        style={{ opacity: "0.4" }}
                                                                        className={`smallTagColor-${theme}`}>
                                                                        Avg Unit Cost
                                                                    </small>
                                                                    <p
                                                                        style={{
                                                                            fontWeight: 600,
                                                                            whiteSpace: "break-spaces"
                                                                        }}
                                                                        className='mb-0 text-primary table_heading_large'>
                                                                        <small
                                                                            className='xSmall'
                                                                        >
                                                                            Rs.
                                                                        </small>
                                                                        {
                                                                            numberWithCommas(avgUnitCost?.toString()?.includes(".") ?
                                                                                avgUnitCost?.toString()?.split(".")[0] :
                                                                                avgUnitCost || 0)
                                                                        }
                                                                        <small className='xSmall'>
                                                                            .{
                                                                                avgUnitCost?.toString()?.includes(".") ?
                                                                                    avgUnitCost?.toString()?.split(".")[1] :
                                                                                    "00"
                                                                            }
                                                                        </small></p>
                                                                </div>
                                                                <div
                                                                    style={{ lineHeight: "normal" }}
                                                                    className='d-flex flex-column align-items-center w-100'>
                                                                    <small
                                                                        style={{ opacity: "0.4" }}
                                                                        className={`smallTagColor-${theme}`}>
                                                                        Total Cost
                                                                    </small>
                                                                    <p
                                                                        style={{
                                                                            fontWeight: 600,
                                                                            whiteSpace: "break-spaces"
                                                                        }}
                                                                        className='mb-0 text-primary table_heading_large'>
                                                                        <small
                                                                            className='xSmall'
                                                                        >
                                                                            Rs.
                                                                        </small>
                                                                        {
                                                                            numberWithCommas(totalCost?.toString()?.includes(".") ?
                                                                                totalCost?.toString()?.split(".")[0] :
                                                                                totalCost || 0)
                                                                        }
                                                                        <small className='xSmall'>
                                                                            .{
                                                                                totalCost?.toString()?.includes(".") ?
                                                                                    totalCost?.toString()?.split(".")[1] :
                                                                                    "00"
                                                                            }
                                                                        </small></p>
                                                                </div>
                                                                <div
                                                                    style={{ lineHeight: "normal" }}
                                                                    className='d-flex flex-column align-items-center w-100'>
                                                                    <small
                                                                        style={{ opacity: "0.4" }}
                                                                        className={`smallTagColor-${theme}`}>
                                                                        Market Value
                                                                    </small>
                                                                    <p
                                                                        style={{
                                                                            fontWeight: 600,
                                                                            whiteSpace: "break-spaces"
                                                                        }}
                                                                        className='mb-0 text-primary table_heading_large'>
                                                                        <small
                                                                            className='xSmall'
                                                                        >
                                                                            Rs.
                                                                        </small>
                                                                        {
                                                                            numberWithCommas(item?.marketData?.market_value?.toString()?.includes(".") ?
                                                                                item?.marketData?.market_value?.toString()?.split(".")[0] :
                                                                                item?.marketData?.market_value || 0)
                                                                        }
                                                                        <small className='xSmall'>
                                                                            .{
                                                                                item?.marketData?.market_value?.toString()?.includes(".") ?
                                                                                    item?.marketData?.market_value?.toString()?.split(".")[1] :
                                                                                    "00"
                                                                            }
                                                                        </small></p>
                                                                </div>
                                                                <div
                                                                    style={{ lineHeight: "normal" }}
                                                                    className='d-flex flex-column align-items-center w-100'>
                                                                    <small
                                                                        style={{ opacity: "0.4" }}
                                                                        className={`smallTagColor-${theme}`}>
                                                                        Market Rate/Unit
                                                                    </small>
                                                                    <p
                                                                        style={{
                                                                            fontWeight: 600,
                                                                            whiteSpace: "break-spaces"
                                                                        }}
                                                                        className='mb-0 text-primary table_heading_large'>
                                                                        <small
                                                                            className='xSmall'
                                                                        >
                                                                            Rs.
                                                                        </small>
                                                                        {
                                                                            numberWithCommas(item?.marketData?.market_rate_per_unit?.toString()?.includes(".") ?
                                                                                item?.marketData?.market_rate_per_unit?.toString()?.split(".")[0] :
                                                                                item?.marketData?.market_rate_per_unit || 0)
                                                                        }
                                                                        <small className='xSmall'>
                                                                            .{
                                                                                item?.marketData?.market_rate_per_unit?.toString()?.includes(".") ?
                                                                                    item?.marketData?.market_rate_per_unit?.toString()?.split(".")[1] :
                                                                                    "00"
                                                                            }
                                                                        </small></p>
                                                                </div>
                                                                <div
                                                                    style={{ lineHeight: "normal" }}
                                                                    className='d-flex flex-column align-items-center w-100'>
                                                                    <small
                                                                        style={{ opacity: "0.4" }}
                                                                        className={`smallTagColor-${theme}`}>
                                                                        Return (Profit/Loss)
                                                                    </small>
                                                                    <p
                                                                        style={{
                                                                            fontWeight: 600,
                                                                            whiteSpace: "break-spaces",
                                                                            color: Number(diffValReturn) > 0 ?
                                                                                "#05bd64" :
                                                                                Number(diffValReturn) < 0 ?
                                                                                    "#de4f45" :
                                                                                    "#7ac6e1"
                                                                        }}
                                                                        className='mb-0 table_heading_large'>
                                                                        <small
                                                                            className='xSmall'
                                                                        >
                                                                            Rs.
                                                                        </small>
                                                                        {
                                                                            numberWithCommas(Number(diffValReturn)?.toFixed(0) || 0)
                                                                        }
                                                                        <small className='xSmall'>
                                                                            {" "}{
                                                                                diffValReturn?.toString()?.includes("-") ? "Loss" : "Profit"
                                                                            }
                                                                        </small></p>
                                                                </div>
                                                                <div
                                                                    style={{ lineHeight: "normal" }}
                                                                    className='d-flex flex-column align-items-center w-100'>
                                                                    <small
                                                                        style={{ opacity: "0.4" }}
                                                                        className={`smallTagColor-${theme}`}>
                                                                        Return %
                                                                    </small>
                                                                    <p
                                                                        style={{
                                                                            fontWeight: 600,
                                                                            whiteSpace: "break-spaces",
                                                                            color: Number(ReturnValInPercentage) > 0 ?
                                                                                "#05bd64" :
                                                                                Number(ReturnValInPercentage) < 0 ?
                                                                                    "#de4f45" :
                                                                                    "#7ac6e1"
                                                                        }}
                                                                        className='mb-0 table_heading_large'>
                                                                        <small
                                                                            className='xSmall'
                                                                        >
                                                                            Rs.
                                                                        </small>
                                                                        {
                                                                            ReturnValInPercentage
                                                                        }
                                                                        <small className='xSmall'>
                                                                            %
                                                                        </small></p>
                                                                </div>
                                                                <div
                                                                    style={{ lineHeight: "normal" }}
                                                                    className='d-flex flex-column align-items-center w-100'>
                                                                    <small
                                                                        style={{ opacity: "0.4" }}
                                                                        className={`smallTagColor-${theme}`}>
                                                                        Unredeemed Amount
                                                                    </small>
                                                                    <p
                                                                        style={{
                                                                            fontWeight: 600,
                                                                            whiteSpace: "break-spaces"
                                                                        }}
                                                                        className='mb-0 table_heading_large text-primary'>
                                                                        {numberWithCommas(item?.marketData?.unredeem_value)}
                                                                    </p>
                                                                </div>
                                                                <div
                                                                    style={{ lineHeight: "normal" }}
                                                                    className='d-flex flex-column align-items-center w-100'>
                                                                    <small
                                                                        style={{ opacity: "0.4" }}
                                                                        className={`smallTagColor-${theme}`}>
                                                                        Remaining Days
                                                                    </small>
                                                                    <p
                                                                        style={{
                                                                            fontWeight: 600,
                                                                            whiteSpace: "break-spaces"
                                                                        }}
                                                                        className='mb-0 table_heading_large text-primary'>
                                                                        {
                                                                            numberWithCommas(moment(item?.marketData?.maturity_date).diff(moment(), 'days') || 0)
                                                                        }
                                                                    </p>
                                                                </div>

                                                            </div>
                                                        </Col>
                                                    )
                                                })}
                                            </Row> */}
                                            {itemsToShow < marketPortfolio?.length && (
                                                <div className='d-flex justify-content-center my-2'>
                                                    <Button
                                                        id='hoverNoEffect'
                                                        style={{
                                                            background: "none"
                                                        }}
                                                        className=' border border-primary'
                                                        size="md"
                                                        onClick={handleShowMore}

                                                    >
                                                        Show More
                                                    </Button>
                                                </div>
                                            )}
                                        </Col>
                                    }
                                </div>
                            </div>
                        </Container>
                    </Col>
                </Row> :
                <div className="d-flex justify-content-center my-3 w-100">
                    <i
                        className="fa fa-spinner fa-spin fa-3x"
                        aria-hidden="true"
                    ></i>
                </div>
            }

        </div >

    )
}

export default Market_portfolio